import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center gap-3" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex flex-row items-center justify-center" }
const _hoisted_4 = { class: "text-center mt-1" }
const _hoisted_5 = { class: "w-36 flex flex-col justify-center items-center p-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "active:text-vue-color" }
const _hoisted_8 = { class: "rounded-full overflow-hidden ml-2 flex justify-center items-center" }
const _hoisted_9 = ["checked"]

import { useGlobalStore } from "@/stores/GlobalStore";
import DropDownReuse from "../DropDownReuse.vue";
import { computed, ref } from "vue";
import ChevronDownIcon from "@/assets/icons/ChevronDownIcon.vue";
import ChevronUpIcon from "@/assets/icons/ChevronUpIcon.vue";
import { watch } from "vue";
import { useToDoStore } from "@/stores/ToDoStore";
type QuickSetting = {
  text: string;
  isChecked: boolean;
  eventFunction: (arg: any) => void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'TodoNavbarSettings',
  setup(__props) {

document.title = "To-Do List";
document.querySelector('meta[name="description"]')!.setAttribute("content", "To-Do List");
const globalStore = useGlobalStore();
const isOpen = ref(false);
const isMounted = ref(true);
const handleReturnIsOpen = (returnedState: boolean) => {
  isOpen.value = returnedState;
};

const todoStore = useToDoStore();
const quickSettings = computed(() => [
  {
    text: "Hide done",
    isChecked: todoStore.settings.hideCompleted,
    eventFunction() {
      todoStore.settingsActions().toggleHideCompleted();
    },
  },
]);

const computedActiveHoverClass = computed(() => {
  return "hover:outline hover:outline-vue-color hover:outline-1 rounded-lg active:text-vue-color active:outline active:outline-vue-color active:outline-1";
});
watch(isOpen, () => {
  isMounted.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "h1 m-3 my-4" }, "To-Do List", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DropDownReuse, {
        "button-class": " pb-2 px-1 text-xl leading-none bg-transparent border border-transparent rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 hover:bg-gray-100",
        "parent-class": "relative z-1 bg-red-400",
        "child-class": `absolute ${_unref(globalStore).bgThemeClass} top-2 -left-4 custom-shadow rounded-lg flex flex-col  `,
        "initial-state-boolean": false,
        onReturnIsOpenState: handleReturnIsOpen
      }, {
        icon: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createTextVNode(" Quick ")),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-block", isMounted.value ? '' : isOpen.value ? 'spin' : 'respin'])
              }, "⚙️", 2)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              (!isOpen.value)
                ? (_openBlock(), _createBlock(ChevronDownIcon, { key: 0 }))
                : (_openBlock(), _createBlock(ChevronUpIcon, { key: 1 }))
            ])), [
              [_directive_auto_animate]
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: { name: 'todoSettings' },
              class: _normalizeClass(["underline p-2", computedActiveHoverClass.value])
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Go to Settings")
              ])),
              _: 1
            }, 8, ["class"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickSettings.value, (quickSetting) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["flex items-center cursor-pointer p-2", computedActiveHoverClass.value]),
                onClick: quickSetting.eventFunction
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(quickSetting.text), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("input", {
                    tabindex: "-1",
                    type: "checkbox",
                    class: "text-green-600 h-6 w-6 focus:ring-green-500 border-gray-300",
                    checked: quickSetting.isChecked
                  }, null, 8, _hoisted_9)
                ])
              ], 10, _hoisted_6))
            }), 256))
          ])
        ]),
        _: 1
      }, 8, ["child-class"])
    ])
  ]))
}
}

})